import { Injectable, inject } from '@angular/core';
import { PreloadingStrategy, Route } from '@angular/router';
import { Observable, of, timer } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';

@Injectable({ providedIn: 'root' })
export class AuthenticatedPreloadingStrategy implements PreloadingStrategy {
  private readonly authService = inject(AuthService);

  preload(route: Route, load: () => Observable<any>): Observable<any> {
    if (!this.authService.isAuthenticated()) {
      return of(null);
    }
    // Small delay so dashboard renders first before background preloading starts
    return timer(500).pipe(mergeMap(() => load()));
  }
}
